import moment from 'moment';

export const dateFormate = (date: string, format?: string) => {
  if (format) return moment(date).format(format);
  else return moment(date).format('ll');
};
